import { render } from "./PreviewNewsroom.vue?vue&type=template&id=0bda3d2c"
import script from "./PreviewNewsroom.vue?vue&type=script&lang=js"
export * from "./PreviewNewsroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__